import '@/plugins/bootstrap'
let PUBLIC_PATH = '/shared_res/agility/editions/'

import Vue from 'vue'
import VueLanding from 'nespresso-components/landing/VueLanding'

import App from '@/components/views/ViewRoot'

import router from './router'
import scroll from '@/helpers/scroll'

if (process.env.NODE_ENV === 'development') {
    Vue.config.performance = true
    Vue.config.devtools = true
    Vue.config.productionTip = true
    PUBLIC_PATH = '/editions/'
}

export const main = () => {
    Vue.use(VueLanding, {
        project: 'central-editions',
        landing: 'v1',
        centralLandingAlias: 'v1',
        trackingLabelPrefix: 'Central - Editions',
        customCentralUrl: PUBLIC_PATH,
        skipMutationKeys: [
            'link',
            'instagram',
            'youtube',
            'spotify',
            'instagram',
            'whatzap',
            "facebook",
            "pinterest",
            "twitter"
        ],
        sectionTrackingLabels: {}
    })

    router.afterEach((to, from) => {
        const editionNumber = to.params.edition ? to.params.edition : 'home'
        const editionName = to.params.title ? to.params.title : ''
        const language = to.params.language ? to.params.language : 'EN'

        if (from.path === '/') {
            if (to.path !== '/') {
                window.dataLayer = window.dataLayer || []
                /* eslint-disable */
                window.dataLayer.push({
                    pageName: 'Nespresso editions',
                    pageType: 'standalone',
                    pageCategory: 'nespresso-edition',
                    landscape: 'Standalone',
                    language: language,
                    editionNumber: editionNumber,
                    editionName: editionName,
                    event: 'event_pageView'
                })
            }
        } else {
            scroll().toTop()
            let dataLayer = (window.dataLayer) ? window.dataLayer : []
            dataLayer.push({
                event: 'customEvent',
                eventCategory: 'User Engagement',
                eventAction: 'Click Edition',
                eventLabel: 'edition number: ' + editionNumber,
                nonInteraction: 0
            })
            dataLayer.push({
                pageName: 'Nespresso editions',
                pageType: 'standalone',
                pageCategory: 'nespresso-edition',
                landscape: 'Standalone',
                language: language,
                editionNumber: editionNumber,
                editionName: editionName,
                event: 'event_virtualPageView'
            })
        }
    })

    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                if (!(el === event.target || el.contains(event.target))) {
                    vnode.context[binding.expression](event)
                }
            }
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        }
    });

    return new Vue({
        el: '#agilityApp',
        router,
        render: h => h(App)
    })
}

main()
